export default __webpack_public_path__ + "static/media/menu-icon.bbdb4dc1.svg";